import './bouncingWord.css'
import React from 'react'
import styled from 'styled-components'

const BouncingWord = ({text, randomColour}) => {

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function getRandomArbitrary(min, max) {
        return Math.random() * (max - min) + min;
    }

    let xSpeed = getRandomArbitrary(1, 11)
    let ySpeed = getRandomArbitrary(1, 6)
    let width = "100px";
    let height = "30px";

    let colour = "var(--themeColour)";

    if (randomColour) {
        let colours = ["#39ff14", "#00B9FB", "#ff9a00", "#ff00a7", "#009000", "#0066cc", "#aa0114", "#c900ff"];
        colour = colours[getRandomInt(0, 7)];
    }

    const Vars = styled.div`
        --width: ${width};
        --height: ${height};
        --x-speed: ${xSpeed}s;
        --y-speed: ${ySpeed}s;
        --colour: ${colour};
    `

    return (
        <Vars className={"position"}>
            <div className="x">
                <div className="blob y">
                    {text}
                </div>
            </div>
        </Vars>
    )
}

export default BouncingWord